export default "__VITE_ASSET__630c6e9e__"